import React from 'react';
import { useSelector } from 'react-redux';
import { FormTypes } from '../../../pages/account-info/models/form-models';
import { MappedMessage } from '../messages/mapped-message-display';
import { TcsmStates } from '../../../root/tcsm-model';
import { SuccessMessageWithNBA } from '../../models/epi-model';



interface FormSuccessProps {
	types: FormTypes[],
}

const warningForms = [FormTypes.MARITAL_STATUS_DOC_UPLOAD_SUCCESS, FormTypes.MAP_MARITAL_STATUS_DOC_UPLOAD_SUCCESS, FormTypes.PERSON_DOC_UPLOAD_SUCCESS];

export const NoChangeSuffix = '_no_change';

export function FormSuccessMessage(props: FormSuccessProps) {
	const { types } = props;

	const epiConfig = useSelector<TcsmStates, { [key: string]: SuccessMessageWithNBA }>(state => state?.epiProps?.siteSettingsState?.siteSettings.apiResponseMessages);

	if (!types || types.length < 1) return null;

	return (
		<div className='grid-main-content'>
			{types.map(formType => {
				let mappedMessage = epiConfig[formType];

				if (!mappedMessage && formType?.includes(NoChangeSuffix)) {
					mappedMessage = epiConfig[formType.replace(NoChangeSuffix, '')];
				}

				if (mappedMessage) {
					const useWarning = warningForms?.includes(formType) || formType?.toUpperCase()?.endsWith('_WARNING');
					return (
						<MappedMessage key={formType} message={mappedMessage.title} supplement={mappedMessage.message} useWarning={useWarning} />
					);
				}

				return null;
			})}

		</div>
	);
}